import React from 'react';
import { motion } from 'framer-motion';
import { HeartCrackIcon, ZapIcon, ShieldCheckIcon, DownloadIcon, FileTextIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-gradient-to-b from-[#F0EDEB] to-[#FFFFFF] py-20 md:py-28 relative overflow-hidden" data-id="element-95">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#722F37]/10 blur-[120px] rounded-full pointer-events-none" data-id="element-96"></div>

      <div className="max-w-3xl mx-auto px-6 relative z-10" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-98">
          <div className="inline-flex items-center gap-2 bg-[#8B1A2B]/10 border border-[#8B1A2B]/30 text-[#8B1A2B] px-4 py-1.5 rounded-full text-sm font-bold mb-6" data-id="element-99">
            <ZapIcon className="w-4 h-4 fill-current" data-id="element-100" />⚡ OFERTA POR TIEMPO
            LIMITADO
          </div>

          <div className="inline-flex items-center gap-2 bg-[#FFFFFF] border border-black/10 text-[#6B7280] px-4 py-2 rounded-full text-sm font-medium mb-8" data-id="element-101">
            <HeartCrackIcon className="w-4 h-4 text-[#722F37]" data-id="element-102" />
            RESCATE DE PAREJA POST-CRISIS
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2D2D2D] mb-6 leading-tight" data-id="element-103">
            Del estrés a la conexión: estrategias para que el dinero deje de ser un problema entre ustedes.                                                                       
          </h1>

          <p className="text-xl md:text-2xl text-[#6B7280] mb-6 leading-relaxed" data-id="element-104">
            El método de{' '}
            <span className="font-semibold text-[#722F37]" data-id="element-105">
              "Primeros Auxilios Emocionales"
            </span>{' '}
            para parejas que quieren dejar de pelear y salvar su relación.
          </p>

          <div className="flex items-center justify-center gap-2 mb-10" data-id="element-106">
            <div className="flex -space-x-2" data-id="element-107">
              {[1, 2, 3, 4, 5].map(i => <div key={i} className="w-8 h-8 rounded-full bg-[#FFFFFF] border-2 border-[#F0EDEB] flex items-center justify-center overflow-hidden" data-id="element-108">
                  <div className="w-full h-full bg-gradient-to-br from-[#722F37]/40 to-[#722F37]/10" data-id="element-109"></div>
                </div>)}
            </div>
            <p className="text-sm text-[#6B7280] font-medium" data-id="element-110">
              <span className="text-[#722F37] font-bold" data-id="element-111">
                + de 2.400 parejas
              </span>{' '}
              ya lo descargaron
            </p>
          </div>

          {/* Tablet Mockup */}
          <motion.div animate={{
          y: [0, -10, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="w-[280px] md:w-[320px] mx-auto bg-[#1A1A1A] rounded-[2rem] p-3 shadow-2xl border-4 border-[#2D2D2D] relative mb-10" style={{
          transform: 'perspective(1000px) rotateX(5deg)',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(0,0,0,0.1) inset'
        }} data-id="element-112">
            {/* Screen */}
            <div className="w-full h-[380px] bg-gradient-to-br from-[#722F37] to-[#4A1D23] rounded-2xl relative overflow-hidden flex flex-col items-center justify-center p-6 text-center border border-white/10" data-id="element-113">
              {/* PDF Badge */}
              <div className="absolute top-4 right-4 bg-white/20 backdrop-blur-sm text-white text-[10px] font-bold px-2 py-1 rounded" data-id="element-114">
                PDF
              </div>

              {/* Decorative elements */}
              <div className="w-16 h-1 bg-white/20 rounded-full mb-8" data-id="element-115"></div>

              <h3 className="text-2xl font-bold text-white mb-3 font-serif leading-tight" data-id="element-116">
                Rescate de Pareja
                <br data-id="element-117" />
                Post-Crisis
              </h3>
              <p className="text-white/80 text-sm font-medium uppercase tracking-widest border-t border-white/20 pt-3 w-full" data-id="element-118">
                Guía de Supervivencia
                <br data-id="element-119" />
                Emocional
              </p>

              {/* Decorative elements */}
              <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black/40 to-transparent" data-id="element-120"></div>
            </div>
          </motion.div>

          <motion.a href="#cta" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} animate={{
          scale: [1, 1.02, 1],
          boxShadow: ['0 0 0 0 rgba(5, 150, 105, 0)', '0 0 0 15px rgba(5, 150, 105, 0.1)', '0 0 0 0 rgba(5, 150, 105, 0)']
        }} transition={{
          duration: 2,
          repeat: Infinity,
          repeatType: 'reverse'
        }} className="inline-block w-full md:w-auto bg-[#059669] text-white px-8 py-5 rounded-xl text-xl font-bold shadow-[0_10px_25px_-5px_rgba(5,150,105,0.4)] hover:bg-[#047857] transition-colors mb-6" data-id="element-121">
            Quiero el producto para salvar mi relacion
          </motion.a>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-xs md:text-sm text-[#6B7280]" data-id="element-122">
            <div className="flex items-center gap-1.5" data-id="element-123">
              <DownloadIcon className="w-4 h-4 text-[#722F37]" data-id="element-124" />
              Descarga inmediata
            </div>
            <div className="flex items-center gap-1.5" data-id="element-125">
              <ShieldCheckIcon className="w-4 h-4 text-[#722F37]" data-id="element-126" />
              Pago seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-127">
              <FileTextIcon className="w-4 h-4 text-[#722F37]" data-id="element-128" />
              PDF listo para usar
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}